import { PrivateUserUpdate } from 'common/src/api/models/recipe-header-private-user.models';
import { RecipeUser } from 'common/src/api/models/recipe-users.models';
import { useEffect, useState } from 'react';
import { CfDialog } from '../../../../cf-ui/dialogs/Dialog/CfDialog';
import UserSearch, { UserSearchItem } from '../../../site/components/common/UserSearch/UserSearch';

type UserCheckboxDialogProps = {
  title: string;
  users: RecipeUser[];
  defaultCheckedUsers: string[];
  defaultDisabledUsers?: string[];
  onSubmit: (items: PrivateUserUpdate[]) => void;
  isLoading: boolean;
  onClose: () => void;
  subTitleOverride?: string;
};

const getInitialItems = (
  users: RecipeUser[],
  defaultCheckedUsers: string[],
  defaultDisabledUsers?: string[]
): UserSearchItem[] => {
  return users
    .map((u) => ({
      userId: u.UserId,
      userDisplayName: u.UserDisplay,
      userName: u.UserName || '',
      selected: defaultCheckedUsers.includes(u.UserId),
      disabled: defaultDisabledUsers?.includes(u.UserId),
    }))
    .sort((a, b) => a.userDisplayName.toLowerCase().localeCompare(b.userDisplayName.toLowerCase()));
};

export default function UserCheckboxDialog(props: UserCheckboxDialogProps): JSX.Element {
  const [items, setItems] = useState(
    getInitialItems(props.users, props.defaultCheckedUsers, props.defaultDisabledUsers)
  );

  useEffect(() => {
    setItems(getInitialItems(props.users, props.defaultCheckedUsers, props.defaultDisabledUsers));
  }, [props.users, props.defaultCheckedUsers, props.defaultDisabledUsers]);

  const handleSubmit = () => {
    const request: PrivateUserUpdate[] = [];

    for (const option of items) {
      if (option.selected !== props.defaultCheckedUsers.includes(option.userId)) {
        request.push({ UserId: option.userId, IsAdd: option.selected });
      }
    }

    if (request.length === 0) {
      props.onClose();
    } else {
      props.onSubmit(request);
    }
  };

  return (
    <CfDialog
      isOpen
      onClose={props.onClose}
      title={props.title}
      subTitle={
        props?.subTitleOverride
          ? props?.subTitleOverride
          : 'Selected users can view/edit your secret recipe ingredients and steps.'
      }
      primaryButtonProps={{ children: 'Save', onClick: handleSubmit }}
      secondaryButtonProps={{ children: 'Cancel', onClick: props.onClose }}
    >
      <UserSearch items={items} isLoading={props.isLoading} onChange={setItems} checkboxListSx={{ width: '100%' }} />
    </CfDialog>
  );
}
